import { memo, useCallback } from "react";

import { TextField } from "ui/components/TextField/TextField";
import { DatePicker } from "ui/components/DatePicker";
import { RegistrationExpirySearchFormValues } from "services/api/fleet/registrations/types";
import { RegistrationSearchFiltersProps } from "./types";

import { useTranslate } from "helpers";

const initialForm: RegistrationExpirySearchFormValues = {
  search: "",
  expirationDateFrom: null,
  expirationDateTo: null,
  status: "",
};

const RegistrationSearchFilters: React.FC<RegistrationSearchFiltersProps> = (
  props
) => {
  const { formValues, onSearchChange } = props;
  const { t } = useTranslate();

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onSearchChange({ ...formValues, search: e.target.value });
  };

  const handleDateChange = (name: string, value: Date | null) => {
    onSearchChange({ ...formValues, [name]: value });
  };

  const handleResetFormClick = useCallback(() => {
    onSearchChange({ ...initialForm, status: formValues.status });
  }, [onSearchChange, formValues.status]);

  return (
    <>
      <div className=" ">
        <div className="flex flex-wrap items-end gap-3">
          <div className="min-w-[220px]">
            <TextField
              type="text"
              name="search"
              value={formValues.search}
              onChange={handleSearchChange}
              placeholder="Registracija ili VIN..."
              startIcon="../media/icons/search.svg"
              cssClassName="bg-white"
            />
          </div>
          <div className="w-[150px]">
            <DatePicker
              name="expirationDateFrom"
              label="Datum isteka od - do"
              value={formValues.expirationDateFrom}
              onChange={handleDateChange}
              cssClassName="bg-white"
            />
          </div>
          <div className="w-[150px]">
            <DatePicker
              name="expirationDateTo"
              value={formValues.expirationDateTo}
              onChange={handleDateChange}
              cssClassName="bg-white"
            />
          </div>
          <div className="flex items-center pb-2">
            <span
              onClick={handleResetFormClick}
              className="text-xs font-bold cursor-pointer text-gray-700"
            >
              {t("admin.reset")}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(RegistrationSearchFilters);
